import { ActionIcon, Group, Loader, MultiSelect, Skeleton } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { IconBallpen, IconChevronDown } from '@tabler/icons';
import { EventsContext } from '../../../Service/Context/EventsContext';
import { useEventKinds } from '../../../Service/hooks/useEventKinds';
import { DataS } from '../../../Service/DataS';
import { ThemeText } from '../../../Atoms/ThemeText';

const EventKindSelection = () => {
  const { filter, updateFilter } = useContext(EventsContext);
  const { kindsOfInterest } = filter;
  const { loading, kinds } = useEventKinds();
  const navigate = useNavigate();

  return (
    <>
      <Group position="apart" mt="xl" mb="xs">
        <ThemeText pl={10}>Auftragsarten</ThemeText>
        <ActionIcon>
          <IconBallpen size={16} onClick={() => navigate('/settings/eventkinds')} />
        </ActionIcon>
      </Group>
      {loading && <Skeleton width="100%" height={100} />}
      <MultiSelect
        searchable
        placeholder="Suchen"
        m="xs"
        data={DataS.getEventKindsOptions(kinds)}
        variant="filled"
        disabled={loading}
        icon={loading && <Loader size="xs" />}
        styles={{ rightSection: { pointerEvents: 'none' } }}
        rightSection={<IconChevronDown size={14} />}
        value={kindsOfInterest}
        onChange={(value) => updateFilter({ kindsOfInterest: value })}
        rightSectionWidth={25}
      />
    </>
  );
};

export default EventKindSelection;
